module.exports = __webpack_public_path__ + "static/media/avoid-fine.af9906ee.svg";